/* eslint-disable camelcase */
import { DateTime } from 'luxon';
import { UseTerms } from '../constants/useTerms';
import { UseTermsSnapshot } from '../models/UseTerms/UseTerms';
import api from './api';
import { getWorkspaceAliasFromUrl } from '../lib/workspace';
import { getBackVersion } from '../config';

const getUseTerms = (
    useTerms: UseTerms,
    workspaceAlias?: string
): Promise<UseTermsSnapshot | null> =>
    api.request<UseTermsSnapshot | null>({
        method: 'GET',
        url: `${getBackVersion()}/use_terms/${useTerms}`,
        params: {
            workspace_alias: workspaceAlias ?? getWorkspaceAliasFromUrl(),
        },
    });

const insertUseTermsAcceptance = (
    useTerms: UseTerms,
    userAgent: string,
    useTermsVersion: DateTime,
    workspaceAlias?: string
): Promise<UseTermsSnapshot> =>
    api.request<UseTermsSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/use_terms/${useTerms}`,
        data: {
            use_terms: useTerms,
            agent_user_agent: userAgent,
            use_terms_version: useTermsVersion,
        },
        params: {
            workspace_alias: workspaceAlias ?? getWorkspaceAliasFromUrl(),
        },
    });

export default {
    getUseTerms,
    insertUseTermsAcceptance,
};
